import React from 'react';
import { Stack, Radio, RadioGroup } from '@chakra-ui/react';

// Ritorna una tripletta di timestamp in ms (start time window, end time window, orario di reference 13:00 o 20:00 per trovare le quantities dei prodotti)
function TurnSelector({ onTurnChange }) {
  const today = new Date();

  const onChangeHandler = (evt) => {
    // const ONE_TURN = 1
    // const TWO_TURN = 2
    switch (evt.target.value) {
      case 'pranzo':
        onTurnChange(
          today.setHours(0, 0),
          today.setHours(16, 0),
          today.setHours(13, 0) /*, ONE_TURN*/,
        );
        break;
      case 'cena':
        onTurnChange(
          today.setHours(16, 0),
          today.setHours(23, 59),
          today.setHours(20, 0) /*, ONE_TURN*/,
        );
        break;
      // case 'all':
      //   onTimeChange(today.setHours(0, 0), today.setHours(23, 59)/*, TWO_TURN*/);
      //   break;
    }
  };
  return (
    <RadioGroup defaultValue='cena'>
      <Stack spacing={5} direction='row'>
        <Radio onChange={onChangeHandler} colorScheme='red' value='pranzo'>
          Pranzo
        </Radio>
        <Radio onChange={onChangeHandler} colorScheme='red' value='cena'>
          Cena
        </Radio>
        {/* <Radio onChange={onChangeHandler} colorScheme='red' value='all'>
          Tutto
        </Radio> */}
      </Stack>
    </RadioGroup>
  );
}
export default TurnSelector;
